import location from "@/services/location";
import notification from "@/services/notification";

const state = {
  isLoading: false,
  cities: null,
  ncrCities: null,
  provinces: null
};

const getters = {
  isLoading: (state) => state.isLoading,
  cities: (state) => state.cities,
  ncrCities: (state) => state.ncrCities,
  provinces: (state) => state.provinces
};

const mutations = {
  setIsLoading(state, payload) {
    state.errors = payload;
  },
  setCities(state, payload) {
    state.cities = payload;
  },
  setNCRCities(state, payload) {
    state.ncrCities = payload;
  },
  setProvinces(state, payload) {
    state.provinces = payload;
  }
};

const actions = {
  getCities: async ({ commit }) => {
    commit("setIsLoading", true);
    try {
      const { cities } = await location.getCities();
      commit("setCities", cities);
    } catch (errors) {
      notification.warning("Oops, cannot get cities.");
    } finally {
      commit("setIsLoading", false);
    }
  },
  getNCRCities: async ({ commit }) => {
    commit("setIsLoading", true);
    try {
      const { cities } = await location.getCities("NCR");
      commit("setNCRCities", cities);
    } catch (errors) {
      notification.warning("Oops, cannot get cities.");
    } finally {
      commit("setIsLoading", false);
    }
  },
  getProvinces: async ({ commit }) => {
    commit("setIsLoading", true);
    try {
      const { provinces } = await location.getProvinces()
      commit("setProvinces", provinces);
    } catch (errors) {
      notification.warning("Oops, cannot get provinces.");
    } finally {
      commit("setIsLoading", false);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
